import { gql } from "@grandvisionhq/graphql";
import AccountAppointmentFragment from "../../../../fragments/Appointments/operations/fragments/appointment.js";
const appointmentsFragment = gql`
  fragment AppointmentsFragment on Appointment {
    ...AccountAppointmentFragment
  }
  ${AccountAppointmentFragment}
`;
const GET_MY_APPOINTMENTS = gql`
  query getMyAppointments {
    me {
      id
      appointments {
        ...AppointmentsFragment
      }
    }
  }
  ${appointmentsFragment}
`;
export {
  GET_MY_APPOINTMENTS as default
};
//# sourceMappingURL=get-my-appointments.js.map
